import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: o, useRem: t, color: l, withColor: c, removeClassName: n, disableSSR: m, style: i, ...h }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-huodongzhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), height: o ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "32px-æ´»å¨ä¸­å¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: c ? r(l, 0, "#262933") : "#262933",
        datafollowfill: c ? r(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M10.792 4.92a2.225 2.225 0 0 0-2.225 2.226v7.324c.003.957.135 1.813.525 2.516.933 1.685 2.699 3.654 5.37 4.209 1.24.258 2.438 1.297 2.438 2.788v3.096h5.35a.9.9 0 0 1 0 1.8H9.75a.9.9 0 1 1 0-1.8h5.35v-3.096c0-.424-.37-.894-1.005-1.026-3.37-.7-5.5-3.154-6.577-5.098a5.64 5.64 0 0 1-.567-1.53A5.068 5.068 0 0 1 2.6 11.313V9.158a1.87 1.87 0 0 1 1.87-1.87h2.297v-.142a4.025 4.025 0 0 1 4.025-4.025h10.416a4.025 4.025 0 0 1 4.025 4.025v.142h2.297a1.87 1.87 0 0 1 1.87 1.87v2.155c0 2.56-1.9 4.677-4.366 5.018a5.306 5.306 0 0 1-.554 1.421c-.742 1.292-1.966 2.793-3.736 3.835a.9.9 0 0 1-.913-1.551c1.438-.847 2.461-2.088 3.088-3.18.383-.667.514-1.49.514-2.417V7.146a2.225 2.225 0 0 0-2.225-2.225H10.792Zm-4.025 9.534A3.268 3.268 0 0 1 4.4 11.313V9.158a.07.07 0 0 1 .07-.07h2.297v5.366Zm18.466-5.366h2.297a.07.07 0 0 1 .07.07v2.155c0 1.492-1 2.75-2.367 3.14V9.089Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.446 11.214a2.35 2.35 0 0 0 0 3.322l1.886 1.886a2.35 2.35 0 0 0 3.323 0l1.885-1.886a2.35 2.35 0 0 0 0-3.322l-1.885-1.886a2.35 2.35 0 0 0-3.323 0l-1.886 1.886Zm3.212-.56-1.886 1.886a.474.474 0 0 0 0 .67l1.886 1.886a.474.474 0 0 0 .67 0l1.886-1.886a.474.474 0 0 0 0-.67l-1.885-1.886a.475.475 0 0 0-.671 0Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
